// removed by extract-text-webpack-plugin
module.exports = {"alert-modal":"alert-modal","footer":"footer","button-wrapper":"button-wrapper","header":"header","header-type-bold":"header-type-bold","header-icon":"header-icon","header-title":"header-title","close-button":"close-button","classtop-modal-content":"classtop-modal-content","alert-content":"alert-content","classtop-alert-warning":"classtop-alert-warning","classtop-alert-success":"classtop-alert-success","classtop-alert-fail":"classtop-alert-fail","classtop-alert-error":"classtop-alert-error","alert-icon":"alert-icon","alert-text":"alert-text","icon-ok":"icon-ok","fa":"fa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Alert/alert.scss
// module id = vVJg
// module chunks = 0